module.exports = __webpack_public_path__ + "img/folios-icon-active.2de1831a.svg";